export default function CreatePathwayController() {

}